// phase implies that the flow is running.
export enum FlowPhase {
  DOWNLOADING = "downloading",
  PROCESSING = "processing",
  UPLOADING = "uploading",
}

export enum FlowStatus {
  // The flow has not started yet; it is part of a backfill which has other flows running.
  Queued = "queued",
  // The flow has started
  Running = "running",
  // All downloads, processing and uploads for the flow have completed successfully.
  Succeeded = "succeeded",
  // Something failed
  Failed = "failed",
  // The user cancelled this flow
  Cancelled = "cancelled",
}
